import { useEffect } from "react";
import { useMatches } from "react-router";
import { getBrowserAgent } from "./index";

type RouteMatch = {
  id: string;
};

function isExplicitRouteId(id: string) {
  return /^[a-z][a-z_-]*$/.test(id);
}

export function getNewRelicRouteName(matches: readonly RouteMatch[]) {
  const routeId = [...matches]
    .reverse()
    .find((match) => isExplicitRouteId(match.id))?.id;

  return routeId ?? "not_found";
}

export function NewRelicRoute() {
  const matches = useMatches();

  useEffect(() => {
    const agent = getBrowserAgent();
    if (!agent?.setPageViewName || !agent.setCurrentRouteName) return;

    const routeName = getNewRelicRouteName(matches);
    agent.setPageViewName(routeName);
    agent.setCurrentRouteName(routeName);
  }, [matches]);

  return null;
}
